import { BModal } from 'bootstrap-vue'
import store_consultations from '@/store/mods/consultations/consultations'
import sageFemmeApi from '@/modules/sage-femme/api'
import { consultation_issues, clinical_evolutions } from '@/utils/consultation-issues'
import { nextSessionDate } from '@/utils/kine-reeducation'

export default {
    name: 'confirm-fin-consultation',
    components: { BModal },
    props: { kineContext: { type: Object, default: null } },
    data() {
        return {
            visible: false, checked: false, loading: false, error: '', prochaine_date: '', prochaine_enregistree: false,
            stays: [], stays_loading: false, stays_error: '', closure_mode: '', hospital_stay_id: null,
            issue_consultation: '', evolution_clinique: '', orientation_destination: '', issue_commentaire: '',
            reference_destination_type: '', reference_type_consultation_id: null, reference_doctor_id: null,
            reference_catalogue: { specialites: [], confreres: [] }, catalogue_loading: false,
            consultation_issues, clinical_evolutions, context: null
        }
    },
    computed: {
        consultation_api() { return (this.$store.getters.selected_consultation_encours || {}).source_tableau_sage_femme ? sageFemmeApi : store_consultations },
        patient() { return this.$store.getters.patient || {} },
        consultationEnCours() { return this.$store.getters.consultationPatientEnCours || {} },
        discharge_stays() { return this.stays.filter(stay => stay.status === 'ADMITTED') },
        available_issues() {
            return this.stays.length && this.closure_mode === 'only'
                ? [{ value: 'hospitalisation', label: 'Poursuite de l’hospitalisation' }, ...this.consultation_issues]
                : this.consultation_issues
        },
        needs_comment() { return ['reference', 'contre_avis', 'depart_anticipe', 'deces'].includes(this.issue_consultation) },
        confreres_reference() {
            return (this.reference_catalogue.confreres || []).filter(medecin =>
                !this.reference_type_consultation_id || (medecin.specialites || []).map(Number).includes(Number(this.reference_type_consultation_id)))
        },
        comment_label() {
            if (this.issue_consultation === 'reference') return 'Motif de référence / transfert'
            if (this.issue_consultation === 'deces') return 'Note / référence à la documentation dédiée'
            if (this.issue_consultation === 'contre_avis' || this.issue_consultation === 'depart_anticipe') return 'Contexte du départ'
            return 'Précision complémentaire (facultative)'
        }
    },
    methods: {
        async open() {
            if (this.loading) return
            const consultation = this.consultationEnCours
            const patient = this.patient
            if (!Number.isInteger(Number(consultation.id)) || Number(consultation.id) < 1 || Number(consultation.patient_id) !== Number(patient.id) ||
                Number(consultation.is_start) !== 1 || Number(consultation.is_end) !== 0) return
            this.context = { consultation_id: Number(consultation.id), patient_id: Number(patient.id),
                patient_nom: [patient.nom, patient.prenoms].filter(Boolean).join(' '), dossier: patient.code || '—' }
            this.issue_consultation = ''
            this.evolution_clinique = ''
            this.orientation_destination = ''
            this.issue_commentaire = ''
            this.reference_destination_type = ''
            this.reference_type_consultation_id = null
            this.reference_doctor_id = null
            this.reference_catalogue = { specialites: [], confreres: [] }
            this.checked = false
            this.error = ''
            this.prochaine_enregistree = false
            this.prochaine_date = ''
            if (this.kineContext && this.kineContext.reeducation) {
                try { this.prochaine_date = nextSessionDate(this.kineContext.reeducation.frequence, this.kineContext.fuseau) }
                catch (_) { this.error = 'Le fuseau de l’établissement est absent ou invalide. Vérifiez les Paramètres.' }
            }
            this.visible = true
            this.stays = []
            this.stays_loading = false
            this.stays_error = ''
            this.closure_mode = ''
            this.hospital_stay_id = null
            this.chargerCatalogue()
            // SF-001 closes the CPN only; it does not grant hospital discharge authority.
            if (this.consultation_api === store_consultations) await this.chargerSejours()
        },
        async chargerSejours() {
            const context = this.context
            this.stays_loading = true
            this.stays_error = ''
            try {
                const access = await store_consultations.getTableauMedecinAccess()
                if (!access || !access.success || !access.data || !access.data.access_token) throw new Error()
                const result = await store_consultations.getClotureContexte(context.consultation_id, access.data.access_token)
                if (this._isDestroyed || !this.visible || this.context !== context) return
                if (!result || result.success !== true || !result.data || !Array.isArray(result.data.stays)) throw new Error()
                this.stays = result.data.stays
                this.hospital_stay_id = this.discharge_stays.length === 1 ? Number(this.discharge_stays[0].id) : null
            } catch (_) {
                if (!this._isDestroyed && this.context === context) this.stays_error = 'Impossible de vérifier l’hospitalisation. Réessayez avant de clôturer.'
            } finally {
                if (!this._isDestroyed && this.context === context) this.stays_loading = false
            }
        },
        async chargerCatalogue() {
            this.catalogue_loading = true
            const consultation_id = this.context && this.context.consultation_id
            try {
                const access = await this.consultation_api.getTableauMedecinAccess()
                if (!access || !access.success || !access.data || !access.data.access_token) return
                const catalogue = await this.consultation_api.getReferenceCatalogue({ access_token: access.data.access_token })
                if (this._isDestroyed || !this.visible || !this.context || this.context.consultation_id !== consultation_id) return
                this.reference_catalogue = { specialites: Array.isArray(catalogue.specialites) ? catalogue.specialites : [],
                    confreres: Array.isArray(catalogue.confreres) ? catalogue.confreres : [] }
            } catch (_) {
                // La clôture ordinaire reste disponible si le catalogue est momentanément indisponible.
            } finally {
                if (!this._isDestroyed) this.catalogue_loading = false
            }
        },
        cancel() { if (!this.loading) this.visible = false },
        prochaine_seance() {
            if (!this.sameContext() || !this.kineContext || this.loading) return
            this.$emit('prochaine-seance', { kine: true, fuseau: this.kineContext.fuseau, date: this.prochaine_date })
        },
        beforeHide(event) { if (this.loading) event.preventDefault() },
        sameContext() {
            return this.context && Number(this.consultationEnCours.id) === this.context.consultation_id &&
                Number(this.consultationEnCours.patient_id) === this.context.patient_id && Number(this.patient.id) === this.context.patient_id
        },
        validate() {
            if (!this.sameContext()) return 'Le contexte patient a changé. Fermez cette fenêtre et rouvrez la consultation souhaitée.'
            if (Number(this.consultationEnCours.is_start) !== 1 || Number(this.consultationEnCours.is_end) !== 0) return 'Cette consultation n’est plus en cours. Actualisez la liste.'
            if (this.stays_loading || this.stays_error) return 'La vérification de l’hospitalisation doit être terminée avant la clôture.'
            if (this.discharge_stays.length && !['only', 'discharge'].includes(this.closure_mode)) return 'Choisissez la clôture seule ou la clôture avec autorisation de sortie.'
            if (this.closure_mode === 'discharge') {
                if (!this.discharge_stays.some(stay => Number(stay.id) === Number(this.hospital_stay_id))) return 'Choisissez le séjour concerné par la sortie.'
            }
            if (!this.available_issues.some(item => item.value === this.issue_consultation)) return 'Choisissez l’issue de la consultation.'
            if (!this.clinical_evolutions.some(item => item.value === this.evolution_clinique)) return 'Choisissez l’évolution clinique.'
            if (this.issue_consultation === 'reference') {
                if (!['interne', 'externe'].includes(this.reference_destination_type)) return 'Choisissez une référence interne ou externe.'
                if (this.reference_destination_type === 'interne' && !(Number(this.reference_type_consultation_id) > 0)) return 'Choisissez la spécialité cible.'
                if (this.reference_destination_type === 'externe' && !this.orientation_destination.trim()) return 'Renseignez la destination externe.'
            }
            if (this.needs_comment && !this.issue_commentaire.trim()) return 'Renseignez le motif ou le contexte de cette issue.'
            if (this.orientation_destination.trim().length > 255 || this.issue_commentaire.trim().length > 2000) return 'La destination est limitée à 255 caractères et la précision à 2 000 caractères.'
            if (!this.checked) return 'Confirmez explicitement la clôture de cette consultation.'
            return ''
        },
        async endConsultation() {
            if (this.loading || !this.visible) return
            this.error = this.validate()
            if (this.error) return
            const consultation_id = this.context.consultation_id
            const payload = {
                issue_consultation: this.issue_consultation,
                evolution_clinique: this.evolution_clinique,
                orientation_destination: this.issue_consultation === 'reference' ? this.orientation_destination.trim() : null,
                issue_commentaire: this.issue_commentaire.trim() || null
            }
            if (this.issue_consultation === 'reference') {
                payload.reference_destination_type = this.reference_destination_type
                payload.reference_type_consultation_id = this.reference_destination_type === 'interne' ? Number(this.reference_type_consultation_id) : null
                payload.reference_doctor_id = this.reference_destination_type === 'interne' && Number(this.reference_doctor_id) > 0 ? Number(this.reference_doctor_id) : null
            }
            if (this.closure_mode === 'discharge') {
                payload.authorize_discharge = true
                payload.hospital_stay_id = Number(this.hospital_stay_id)
            }
            this.loading = true
            try {
                const api = this.consultation_api
                const access = await api.getClotureMedecinAccess()
                if (this._isDestroyed) return
                if (!this.sameContext()) throw new Error('Le contexte patient a changé. Aucune clôture n’a été envoyée.')
                if (!access || access.success !== true || !access.data || typeof access.data.access_token !== 'string' || !access.data.access_token) {
                    throw new Error('L’autorisation de clôture est indisponible. Réessayez.')
                }
                const result = await api.cloturerConsultationMedecin(consultation_id, payload, access.data.access_token)
                if (this._isDestroyed) return
                if (!result || result.success !== true || Number(result.consultation_id) !== consultation_id) {
                    throw new Error(result && typeof result.message === 'string' ? result.message : 'La clôture n’a pas été confirmée. Actualisez la liste avant de réessayer.')
                }
                window.dispatchEvent(new CustomEvent('clinicaa:consultation-updated', { detail: { consultation_id } }))
                if (!this.sameContext()) {
                    this.error = 'La consultation initiale a été clôturée. Le contexte patient a changé ; aucune navigation automatique n’a été effectuée.'
                    return
                }
                this.loading = false
                this.visible = false
                this.$store.commit('SET_SELECTED_CONSULTATION_ENCOURS', {})
                await this.$router.push({ path: '/dashboard' })
            } catch (error) {
                if (this._isDestroyed) return
                const response = error && error.response
                const response_data = response && response.data
                this.error = response_data && typeof response_data.message === 'string' ? response_data.message :
                    (error && typeof error.message === 'string' ? error.message : 'La clôture n’a pas pu être effectuée. Réessayez.')
            } finally {
                if (!this._isDestroyed) this.loading = false
            }
        }
    }
}
